import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose See where the fleet's LINKA locks are on a map (in development)
 * @primary Map
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/map/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
